import { render, staticRenderFns } from "./createlifeinpaxel.vue?vue&type=template&id=432eaf3a&"
import script from "./createlifeinpaxel.vue?vue&type=script&lang=js&"
export * from "./createlifeinpaxel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports